import Vue from 'vue';
import App from './App.vue';
import router from './router';
import AuthService from './utils/msal';
import vuetify from './plugins/vuetify';
import moment from 'moment';
import { store } from './store';
import VueTheMask from 'vue-the-mask';
import { getCmsConfig } from './api/common';
import sanityClient from '@sanity/client';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export let sanity = {};

const getTenant = `*[_type == "config"]{
				tenant,
				business{name},
				"favicon":favicon.favicon.asset->url,
				colors
			}`;
start().then(() => {});

async function start() {
  if (!localStorage.getItem('test')) {
    const appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: '6fb8b15b-bdcf-4b12-8ac3-ed95aa0b6f64',
        enableAutoRouteTracking: true,
      },
    });
    console.log(appInsights);

    appInsights.loadAppInsights();
    appInsights.trackPageView();
  }
  try {
    await getInitFileConfig();
    Vue.prototype.$sanity = await initCms(await localStorage.tenant);
    Vue.use(VueTheMask);
    Vue.prototype.$moment = moment;
    Vue.prototype.$AuthService = new AuthService();
    Vue.config.productionTip = false;

    new Vue({
      router,
      vuetify,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  } catch (error) {
    console.log(error);
  }
}

async function getInitFileConfig() {
  let res = await fetch('/init.json');
  res = await res.json();
  if (res.b2b_configs && res.api_url && res.tenant) {
    localStorage.api_url = res.api_url;
    if (res.api_url.includes('api-dev')) {
      localStorage.env = 'dev';
    } else if (res.api_url.includes('api-qa')) {
      localStorage.env = 'qa';
    } else if (res.api_url.includes('api-stag')) {
      localStorage.env = 'stag';
    } else {
      localStorage.env = 'prod';
    }
    localStorage.tenant = res.tenant;
    localStorage.bankNumber = res.bank_number;
    localStorage.msalConfig = JSON.stringify(res.b2b_configs.msalConfig);
    localStorage.loginRequest = JSON.stringify(res.b2b_configs.loginRequest);
    localStorage.tokenRequest = JSON.stringify(res.b2b_configs.tokenRequest);
    localStorage.forgotPasswordRequest = JSON.stringify(
      res.b2b_configs.b2cPolicies.authorities.forgotPassword
    );
  }
}

async function initCms(tenantId) {
  let res = await (await getCmsConfig(tenantId)).json();
  let dataset = '';
  if (localStorage.env === 'dev') {
    dataset = 'development';
  } else if (localStorage.env === 'qa') {
    dataset = 'qa';
  } else if (localStorage.env === 'stag') {
    dataset = 'staging';
  } else {
    dataset = 'production';
  }
  let sanityConfig = res.find((item) => item.dataset === dataset);
  sanity = new sanityClient({
    projectId: sanityConfig.projectId,
    dataset: sanityConfig.dataset,
    token: sanityConfig.token,
    ignoreBrowserTokenWarning: true,
    useCdn: false,
    apiVersion: '2021-03-25',
  });
  let tenant = await sanity.fetch(getTenant);
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = tenant[0].favicon;
  document.getElementsByTagName('head')[0].appendChild(link);

  const maskLink = document.createElement('link');
  maskLink.rel = 'mask-icon';
  maskLink.href = tenant[0].favicon;
  maskLink.setAttribute('color', tenant[0].colors.primary);
  document.getElementsByTagName('head')[0].appendChild(maskLink);

  document.title = `${tenant[0].business.name} - MinSide`;
  return sanity;
}
